import { Space, Typography, Input, Select } from "antd";
import { IDrone } from "@drone-parts.garphild.pro/interfaces";

interface IOtherPartsTabProps {
  drone: IDrone;
  mainParts: string[];
  statusesList: { value: string; label: string }[];
  onChangeStatus: (status: string) => void;
  handleChangeIncome: (income: number) => void;
}

export default function OtherPartsTab({
  drone,
  mainParts,
  statusesList,
  onChangeStatus,
  handleChangeIncome,
}: IOtherPartsTabProps) {
  return (
    <Space direction="vertical" style={{ zIndex: 10000, width: '100%' }}>
      <Space direction="horizontal" style={{ justifyContent: "space-between", display: 'flex', width: '100%' }} >
        <Typography>Base price USD:</Typography><Typography>{drone.total?.toFixed(2)}</Typography>
      </Space>
      <Space direction="horizontal" style={{ justifyContent: "space-between", display: 'flex' }} >
        <Typography>Fee USD:</Typography><Typography>50.00</Typography>
      </Space>
      <Space direction="horizontal" style={{ justifyContent: "space-between", display: 'flex' }} >
        <Typography>Total USD:</Typography><Typography>{(drone.total + 50)?.toFixed(2)}</Typography>
      </Space>
      <Space direction="horizontal" style={{ justifyContent: "space-between", display: 'flex' }} >
        <Typography>Donated USD:</Typography>
        <Typography>
          <Input
            placeholder="Income"
            defaultValue={drone.income}
            style={{ width: 100 }}
            onChange={(e) => {
              handleChangeIncome(parseFloat(e.target.value.replace(",", ".")));
            }}
          />
        </Typography>
      </Space>
      <Space direction="horizontal" style={{ justifyContent: "space-between", display: 'flex' }} >
        <Typography>Revenue, USD:</Typography><Typography>{((drone.income || 0) - (drone.total || 0))?.toFixed(2)}</Typography>
      </Space>
      <Space style={{ display: 'flex', justifyContent: 'space-between', width: '100%'}}>
        <Typography>
          Status:
        </Typography>
        <Select
          value={drone.status || "draft"}
          style={{ width: 200 }}
          onChange={onChangeStatus}
          options={statusesList || []}
        />
      </Space>
      {drone.parts
        .filter((part) => !mainParts.includes(part.key))
        .map((part) => {
          const { item, key, price, quantity } = part;
          return (
            <Space key={key} direction="horizontal"
                   style={{ justifyContent: "space-between", display: 'flex' }}>
              <Typography>{item?._id && !item?.received ? "(Awaiting) " : ""}{item?.shortName}</Typography>
              <Typography>{JSON.stringify(key)}</Typography>
              <Typography>{quantity} x {price}</Typography>
            </Space>
          );
        })}
    </Space>
  );
}
